import { makeStyles } from '@material-ui/core/styles'

export const virtualBoreholeMetaStyle = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: '0.8rem'
  },
  title: {
    fontWeight: 500,
    fontSize: '0.7rem',
    color: theme.palette.geoColors.text.light
  }
}))
